import React, { FC } from 'react';

import TextInputBase from '../../base/TextInputBase';
import { TextInputProps } from 'react-native';
import styles from './styles';
import View from '../View';

type TextInputStyledProps = {
  editable?: boolean;
  errorMessage?: string | boolean;
  imageKey?: string;
  imageStyle?: any;
  invalidCharacters?: string;
  label?: string;
  labelHidden?: boolean;
  onBlur?: Function;
};

export type InputProps = TextInputStyledProps & TextInputProps;

export const TextInput: FC<InputProps> = (props) => {
  const {
    autoCapitalize,
    autoCompleteType,
    autoCorrect = false,
    editable = true,
    errorMessage,
    imageKey,
    imageStyle,
    invalidCharacters = '',
    keyboardType,
    label,
    labelHidden,
    multiline,
    numberOfLines,
    placeholder,
    onBlur,
    onChangeText,
    onFocus,
    onKeyPress,
    onSubmitEditing,
    onSelectionChange,
    secureTextEntry,
    textContentType,
    value,
  } = props;

  const blurInputContainerStyle = imageKey
    ? styles.blurInputContainerWithImage
    : styles.blurInputContainer;
  const disabledContainerStyle = imageKey
    ? styles.disabledInputContainerWithImage
    : styles.disabledInputContainer;
  const errorInputContainerStyle = imageKey
    ? styles.errorInputContainerWithImage
    : styles.errorInputContainer;
  const focusInputContainerStyle = imageKey
    ? styles.focusInputContainerWithImage
    : styles.focusInputContainer;

  const selectedImageStyle = imageStyle || styles.imageStyle;
  return (
    <View style={styles.wrapper}>
      <TextInputBase
        autoCorrect={autoCorrect}
        autoCapitalize={autoCapitalize}
        autoCompleteType={autoCompleteType}
        blurInputContainerStyle={blurInputContainerStyle}
        containerStyle={styles.container}
        disabledContainerStyle={disabledContainerStyle}
        disabledTextInputStyle={styles.disabledTextInput}
        editable={editable}
        errorInputContainerStyle={errorInputContainerStyle}
        errorMessageTextStyle={styles.errorMessageText}
        errorMessage={errorMessage}
        focusInputContainerStyle={focusInputContainerStyle}
        imageKey={imageKey}
        imageStyle={selectedImageStyle}
        keyboardType={keyboardType}
        label={label}
        labelHidden={labelHidden}
        labelStyle={styles.label}
        multiline={multiline}
        numberOfLines={numberOfLines}
        placeholder={placeholder}
        onBlur={onBlur}
        onFocus={onFocus}
        onChangeText={onChangeText}
        onKeyPress={onKeyPress}
        onSubmitEditing={onSubmitEditing}
        onSelectionChange={onSelectionChange}
        secureTextEntry={secureTextEntry}
        textInputStyle={styles.textInput}
        textContentType={textContentType}
        value={value}
      />
    </View>
  );
};

export default TextInput;
